import styled from 'styled-components'

export const Container = styled.div`
  margin-bottom: var(--space-200);

  font-size: var(--font-size-400);
  line-height: var(--font-line-height-400);
  font-weight: var(--font-weight-regular);
  color: var(--text-primary);
`

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
`

export const Tooltip = styled.div`
  margin-left: var(--space-200);
`
